"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "useScreenShareStartedAction", {
  enumerable: true,
  get: function get() {
    return _useScreenShareStartedAction.useScreenShareStartedAction;
  }
});
var _useScreenShareStartedAction = require("./useScreenShareStartedAction");